import React, { useEffect, useState } from "react";
import {
  FaUsersCog,
  FaUserPlus,
  FaRegChartBar,
  FaCog,
} from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import "../../assets/css/sidenav.css";
import $ from "jquery";
import Logout from "../auth/Logout";
import { useSidebarMenu } from "../../hooks/useSidebarMenu";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import DashboardIcon from "@mui/icons-material/Dashboard";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function SideMenu({
  name,
  pages,
  id,
  setcurrentPage,
  activeCurrentPage,
  activeIndexData,
  reportnameFetch,
  Embedaccess_token,
}) {
  const { fetchMenu, fetchUserRole } = useSidebarMenu();
  const [pathValueData, setpathValueData] = useState("");
  const [, setError] = useState(null);
  const [, setisReport] = useState(false);
  const { ReportID } = useParams();
  const [getreportPages, setReportpage] = useState(() => {
    try {
      const cached = sessionStorage.getItem("sidemenu-data");
      return cached ? JSON.parse(cached) : {};
    } catch {
      return {};
    }
  });
  const [PageAuth] = useState(true);
  const [userRole, setuserRole] = useState(() => {
    try {
      const cached = sessionStorage.getItem("sidemenu-userrole");
      return cached ? JSON.parse(cached) : undefined;
    } catch {
      return undefined;
    }
  });
  const [hide, setHide] = useState(false);
  const [activeIndex, setActiveIndex] = useState(activeIndexData || 0);
  const [reportnameFetchData, setreportnameFetchData] =
    useState(reportnameFetch);

  // Skip the loading skeleton entirely when we already have cached menu data
  const [isLoading, setIsLoading] = useState(
    () => !sessionStorage.getItem("sidemenu-data")
  );

  useEffect(() => {
    if (PageAuth) {
      fetchUserRole()
        .then((userRoleData) => {
          setuserRole(userRoleData);
          sessionStorage.setItem("sidemenu-userrole", JSON.stringify(userRoleData));
        })
        .catch(() => {
          setuserRole();
        });
    }
  }, [PageAuth, fetchUserRole]);

  localStorage.setItem("userType", userRole?.userType);
  // localStorage.setItem("userGroup", userRole?.userGroup);

  const URole = userRole?.userType;

  const CACHE_KEY = "sidemenu-data";

  const fetchSearchByname = async () => {
    // Return cached menu if available — skip API call
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached) {
      try {
        setReportpage(JSON.parse(cached));
        return;
      } catch {
        sessionStorage.removeItem(CACHE_KEY);
      }
    }

    setIsLoading(true);
    try {
      const menuData = await fetchMenu();
      setReportpage(menuData);
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(menuData));
      setError(null);
    } catch (err) {
      setError(err.message);
      setReportpage(null);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchSearchByname();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getUrlData = () => {
    const getURl = new URL(window.location.href);

    const pathValue = getURl.pathname;
    setpathValueData(pathValue);
    if (pathValue === "/") {
      $("#MenuItmes_Overview").addClass("active");
      $(".getInfo").css("display", "none !important");
    }
    if (pathValue === "/userRegistration") {
      $("#MenuItmes_createUsers").addClass("active");
    }
    if (pathValue === "/UserAdministration") {
      $("#MenuItmes_UserAdministration").addClass("active");
    }
    if (pathValue === "/ReportAdministration") {
      $("#MenuItmes_ReportAdministration").addClass("active");
    }
    if (pathValue === "/RolesAdministration") {
      $("#MenuItmes_RolesAdministration").addClass("active");
    }
    if (pathValue === "/PersonaAdministration") {
      $("#MenuItmes_PersonaAdministration").addClass("active");
    }
    if (pathValue === "/settings/visuals") {
      $("#MenuItmes_Settings").addClass("active");
    }
    if (pathValue === "/ReportGenerate") {
      $("#MenuItmes_ReportGenerate").addClass("active");
    }
    if (pathValue === "/settings/visuals") {
      $("#MenuItmes_Settings").addClass("active");
    }
    if (ReportID !== undefined) {
      $("#MenuItmes_Report").addClass("active");
    }
  };

  useEffect(() => {
    getUrlData();
  });


  const checkPath = () => {
    const getURl = new URL(window.location.href);
    // const Idfetch = url.searchParams.get("admClientId");
    const pathValue = getURl.pathname;

    if (
      pathValue === "/" ||
      pathValue === "/userRegistration" ||
      pathValue === "/UserAdministration" ||
      pathValue === "/ReportAdministration" ||
      pathValue === "/RolesAdministration" ||
      pathValue === "/PersonaAdministration"
    ) {
      setisReport(false);
    } else {
      setisReport(true);
    }
  };

  useEffect(() => {
    checkPath();
  }, []);

  //console.log(pathValueData)
  const renderSkeleton = () => (
    <div>
      {Array(4)
        .fill()
        .map((_, i) => (
          <div key={i} style={{ marginBottom: "10px" }}>
            <Skeleton height={40} />
          </div>
        ))}
    </div>
  );

  // console.log(reportnameFetch)

  return (
    <div>
      <div id="mySidenav" className={`sideNav common_bg_color ${name}`}>
        <div className="sideNavMenu">
          <div className="sideNavMenu_grid">
            <div style={{ display: "grid", gridGap: "20px" }}>
              {isLoading ? (
                renderSkeleton()
              ) : (
                <>
                  <Link to={"/"}>
                    <div
                      id="MenuItmes_Overview"
                      style={{ gridGap: "1rem" }}
                      className="items_menu"
                    >
                      <div title="Home">
                        <DashboardIcon sx={{ fontSize: "28px" }} />
                      </div>
                      <div className="item_menuText">Home</div>
                    </div>
                  </Link>

                  <Link to={"/settings/visuals"}>
                    <div
                      id="MenuItmes_Settings"
                      style={{ gridGap: "1rem" }}
                      className="items_menu"
                    >
                      <div title="Customize visuals">
                        <DashboardCustomizeIcon sx={{ fontSize: "28px" }} />
                      </div>
                      <div className="item_menuText">Customize visuals</div>
                    </div>
                  </Link>

                  {URole === "Admin" && (
                    <>
                      <Link to={"/UserAdministration"}>
                        <div
                          id="MenuItmes_UserAdministration"
                          style={{ gridGap: "1rem" }}
                          className="items_menu"
                        >
                          <div>
                            <FaUsersCog title="User Management" fontSize={28} />
                          </div>
                          <div className="item_menuText">User Management</div>
                        </div>
                      </Link>

                      <Link to={"/ReportAdministration"}>
                        <div
                          id="MenuItmes_ReportAdministration"
                          style={{ gridGap: "1rem" }}
                          className="items_menu"
                        >
                          <div>
                            <DashboardCustomizeIcon sx={{ fontSize: "28px" }} />
                          </div>
                          <div className="item_menuText">
                            Report Administration
                          </div>
                        </div>
                      </Link>

                      <Link to={"/RolesAdministration"}>
                        <div
                          id="MenuItmes_RolesAdministration"
                          style={{ gridGap: "1rem" }}
                          className="items_menu"
                        >
                          <div>
                            <FaCog title="Roles Administration" fontSize={28} />
                          </div>
                          <div className="item_menuText">Roles Administration</div>
                        </div>
                      </Link>

                      <Link to={"/PersonaAdministration"}>
                        <div
                          id="MenuItmes_PersonaAdministration"
                          style={{ gridGap: "1rem" }}
                          className="items_menu"
                        >
                          <div>
                            <FaUserPlus
                              title="Persona Administration"
                              fontSize={28}
                            />
                          </div>
                          <div className="item_menuText">
                            Persona Administration
                          </div>
                        </div>
                      </Link>
                    </>
                  )}

                  {pathValueData !== "/" && (
                  <div
                    id="MenuItmes_Report"
                    className="items_menu item_menuText"
                  >
                    <div
                      style={{
                        display: "flex",
                        gridGap: "15px",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <FaRegChartBar title="Reports" fontSize={28} />
                      </div>
                      <div className="item_menuText">Reports</div>
                    </div>
                  </div>
                  )}

                  {pathValueData !== "/" && (
                  <div id="All_reports">
                    {getreportPages?.reports?.map((items, index) => {
                      return (
                        <div
                          id={`report_${items[0]}`}
                          key={index}
                          style={{ display: "grid" }}
                          className="items_menu"
                        >
                          <div
                            style={{
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                            className="item-flex-report"
                          >
                            <div className="item-flex-report">
                              <div style={{ display: "grid" }}>
                                <div
                                  id="reportName_id_name"
                                  className="item_menuText"
                                >
                                  <Link
                                    to={
                                     `/reports/${items[0]}/view?groupId=${items[6]}`
                                    }
                                  >
                                    {items[1]}
                                  </Link>
                                </div>
                              </div>
                            </div>

                            {items[0] === parseInt(id) &&
                            Embedaccess_token !== null ? (
                              <div
                                className="item_menuText getInfo"
                                id={`collapseButton_${items[0]}`}
                                onClick={() => setHide(!hide)}
                              >
                                <i
                                  style={{ cursor: "pointer" }}
                                  className={
                                    hide ? `fa fa-plus` : "fa fa-minus"
                                  }
                                ></i>
                              </div>
                            ) : (
                              <div
                                className="item_menuText getInfo"
                                id={`collapseButton_${items[0]}`}
                              >
                                <Link
                                  to={
                                    items[0] === 118
                                      ? `/LIMS/${items[0]}`
                                      : `/reports/${items[0]}/view`
                                  }
                                >
                                  <i
                                    style={{ cursor: "pointer" }}
                                    className="fa fa-external-link"
                                  ></i>
                                </Link>
                              </div>
                            )}
                          </div>

                          {Embedaccess_token !== null && (
                            <>
                              {items[0] === parseInt(id) ? (
                                <div id="powerbi_emb_report">
                                  {!hide && (
                                    <div id="pbiPages">
                                      <div>
                                        {pages.length !== 0 ? (
                                          <>
                                            {pages &&
                                              pages.map((item, index) => {
                                                return (
                                                  <>
                                                    {item.visibility === 0 && (
                                                      <span
                                                        onClick={(e) => {
                                                          activeCurrentPage(e);
                                                          setActiveIndex(index);
                                                          setreportnameFetchData(
                                                            null
                                                          );
                                                        }}
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        key={index}
                                                        className={
                                                          reportnameFetchData !==
                                                          null
                                                            ? item.isActive ===
                                                              true
                                                              ? "item_menuText mystyle active"
                                                              : "item_menuText mystyle"
                                                            : `item_menuText mystyle ${
                                                                activeIndex ===
                                                                index
                                                                  ? "active"
                                                                  : ""
                                                              }`
                                                        }
                                                      >
                                                        <span className="tooltiptext">
                                                          {item.displayName}
                                                        </span>
                                                        {item.displayName}
                                                      </span>
                                                    )}
                                                  </>
                                                );
                                              })}
                                          </>
                                        ) : (
                                          <>
                                            {Array(2)
                                              .fill()
                                              .map((_, i) => (
                                                <div
                                                  key={i}
                                                  style={{
                                                    marginBottom: "0px",
                                                  }}
                                                >
                                                  <Skeleton height={30} />
                                                </div>
                                              ))}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <></>
                              )}
                            </>
                          )}
                        </div>
                      );
                    })}
                  </div>
                  )}
                </>
              )}
            </div>

            <>
              <Logout />
            </>
          </div>
        </div>
      </div>
    </div>
  );
}
